import React from "react";
import { NavLink } from "react-router-dom";
import { Usecoursecontext } from "./component/coursecontext/course_context";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay  , Pagination} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination'; // ✅ required for dots to appear

import Formatprice from "./component/Helper/Formatprice";
import { BASE_URL } from "./Config/Config";
import SubLoading from "./ALL CSS/Loading";
import Course_Card from "./component/GlobelHelper/Course_Card";

function Service() {
     const { isloading , courses } = Usecoursecontext();

  if (isloading) {
    return <div><SubLoading/></div>;
  }
  
  return (
    <>
      <section
        className="space "
        data-bg-src="/assets/img/bg/course_bg_1.png"
        id="course-sec"
      >
        <div className="container">
          <div className="mb-35 text-center text-md-start">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-8">
                <div className="title-area mb-md-0">
                  <span className="sub-title">
                    <i className="fal fa-book me-2"/> Popular Courses
                  </span>
                  <h2 className="sec-title">Our Popular Courses</h2>
                </div>
              </div>
              <div className="col-md-auto">
                <NavLink to="/course" className="th-btn">
                  View All Courses<i className="fa-solid fa-arrow-right ms-2" />
                </NavLink>
              </div>
            </div>
          </div>


<div className="relative">
 {/* <div className="swiper-custom-buttons flex justify-between items-center">
    <button className="custom-prev absolute left-0 top-1/2 -translate-y-1/2 z-10 costom "><i className="fa-regular fa-arrow-right" style={{ transform: 'rotate(180deg)' }} /></button>
    <button className="custom-next absolute right-0 top-1/2 -translate-y-1/2 z-10  costom"><i className="fa-regular fa-arrow-right"></i>
</button>

  </div> */}
          <Swiper
            modules={[Navigation, Pagination , Autoplay , ]}
            navigation={{
      nextEl: '.custom-next',
      prevEl: '.custom-prev',
    }}
    pagination={{ clickable: true }}
            autoplay={{
              delay: 2000, 
              disableOnInteraction: false, 
             
            }}
            spaceBetween={20}
            slidesPerView={4}
           loop={true}
           loopAdditionalSlides={1}
            breakpoints={{
              320: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
          >
            {courses.map((curdata, index) => (
              <SwiperSlide key={index}>

                <Course_Card curdata={curdata}/>

              </SwiperSlide>
            ))}
          </Swiper>
          </div>
        </div>
      </section>
    </>
  );
}

export default Service;

